import './referrals.scss'
import { Copy } from 'lucide-react';
import 'animate.css'
import { useUser } from '../../context/UserContext';
import copy from "copy-to-clipboard";
import { useNotification } from '../../context/NotificationContext';

const Referrals = () => {
    const {currentUser}=useUser()
    const {notify}=useNotification()

    const handleCopy = (text: string) => {
            const success = copy(text);
    
            if (success) {
                notify.success("Copied!");
            } else {
                notify.error("Failed to copy.");
            }
        };

    return (<div className='referral animate__animated animate__fadeIn animate__fast'>

        <div className="centerbox">

            <div className="intro">

                <div className="boxicon"></div>
                <div className="ptitle">Refer and earn  with Yayako</div>
                <div className="ptext">When you invite a friend to shop at Yayako, you earn 10% off on your next order. Everyone wins!</div>

            </div>


            <div className='steppack'>
                <div className='steps circside'>

                    <div className='eachstep'>
                        <div className='stepcirc'>1</div>
                    </div>


                    <div className='eachstep'>
                        <div className='stepcirc'>2</div>
                    </div>


                    <div className='eachstep'>
                        <div className='stepcirc'>3</div>
                    </div>


                </div>
                <div className="steps">
                    <div className='steptext'>Invite your friends</div>
                    <div className='steptext'>They shop</div>
                    <div className='steptext'>You earn</div>
                </div>
            </div>




            <div className='inputside'>
                <div className='label'>Invite your friends</div>
                <div className='refBox'>
                    <input value={`${currentUser?.referral_code || ''}`}></input>
                    <button className='btn' onClick={()=>handleCopy(`${currentUser?.referral_code || ''}`)}>
                        <Copy size={18}></Copy>
                        <span>Copy</span> 
                    </button>
                </div>
            </div>


            {/* <div className='sharetab'>
                <div className='label'>Share With</div>

                <div className='sharegrid'>

                    <div className='eachshare'>
                        <div className='icon link'></div>
                        <div className='text'>Copy Link</div>
                    </div>

                    <div className='eachshare'>
                        <div className='icon whatsapp'></div>
                        <div className='text'>Whatsapp</div>
                    </div>

                    <div className='eachshare'>
                        <div className='icon twitter'></div>
                        <div className='text'>Twitter</div>
                    </div>


                    <div className='eachshare'>
                        <div className='icon messenger'></div>
                        <div className='text'>Messenger</div>
                    </div>

                    <div className='eachshare'>
                        <div className='icon telegram'></div>
                        <div className='text'>Telegram</div>
                    </div>

                    <div className='eachshare'>
                        <div className='icon facebook'></div>
                        <div className='text'>Facebook</div>
                    </div>


                    <div className='eachshare'>
                        <div className='icon more'></div>
                        <div className='text'>More</div>
                    </div>

                </div>

            </div> */}



        </div>

    </div>)
}


export default Referrals;